import { useEffect } from "react"

import { useAuth0 } from "@auth0/auth0-react"
import { useRouter } from "expo-router"

import { Box, Image, Spinner, Text, VStack } from "wealthmode-frontend/gluestack/ui"

export default function Callback() {
  const { user, isAuthenticated, error, isLoading } = useAuth0()
  const router = useRouter()

  useEffect(() => {
    if (!isLoading && !isAuthenticated && !error) {
      router.replace("/login")
    } else if (isAuthenticated && user) {
      setTimeout(() => {
        router.replace("/dashboard")
      }, 1000)
    }
  }, [isLoading, isAuthenticated, error, user, router])

  if (isLoading) {
    return (
      <Box className="bg-background-primary min-h-screen flex items-center justify-center">
        <VStack className="gap-4 items-center">
          <Spinner size="large" />
          <Text className="text-foreground-primary text-lg">Loading user profile...</Text>
        </VStack>
      </Box>
    )
  }

  if (error) {
    return (
      <Box className="bg-background-primary min-h-screen flex items-center justify-center">
        <VStack className="gap-4 items-center">
          <Text className="text-information-negative text-xl">Oops... {error.message}</Text>
        </VStack>
      </Box>
    )
  }

  return (
    <Box className="bg-background-primary min-h-screen flex items-center justify-center">
      <VStack className="gap-4 items-center">
        {user?.picture && (
          <Image
            source={{ uri: user.picture }}
            alt={user.name || "User"}
            className="w-24 h-24 rounded-full"
          />
        )}
        <Text className="text-foreground-primary text-2xl font-bold">{user?.name}</Text>
        <Text className="text-foreground-tertiary">{user?.email}</Text>
        <Text className="text-information-positive text-lg">Authentication successful! Redirecting...</Text>
      </VStack>
    </Box>
  )
}
